import ESSPFRServiceDetail from "./ESSPFRServiceDetail";

export default ESSPFRServiceDetail;
